import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {Grid, List, ListItem} from "@mui/material";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";
import React, {useDebugValue, useEffect} from "react";
import {useVesselCallList} from "~/apps/packages/vessel-calls/hooks";
import { VesselCallItem } from "./VesselCallItem";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {Star} from "@mui/icons-material";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


export type VesselCallListProps = {
    query?: string
    status?: string[]
    dateFrom?: Date
    dateTo?: Date
    favorite?: boolean
    onLoading?: (loading: boolean) => void
}


export const VesselCallList = (props: VesselCallListProps) => {
    const {query, status, dateFrom, dateTo, favorite, onLoading} = props;
    const {data, emptyFavorites, loading, fetchMore, canFetchMore} = useVesselCallList({
        query: query,
        status: status,
        dateFrom: dateFrom,
        dateTo: dateTo,
        favorite: favorite
    });
    const empty = data?.length == 0 && !favorite || favorite && !emptyFavorites && data?.length == 0;

    const setScrollableNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    const handleRef = (node) => {
        setScrollableNode(findScrollableNode(node));
    }

    useEffect(() => {
        onLoading && onLoading(loading);
    }, [loading])


    return (
        <LoadingBox isInitialLoading={data == undefined} loading={loading} empty={empty} placeholder={canFetchMore}>
            {data?.length > 0 && (
                <List ref={handleRef}>
                    {data.map(item => (
                        <ListItem key={item.id}>
                            <VesselCallItem vesselCall={item}/>
                        </ListItem>
                    ))}
                </List>
            )}
            {favorite && emptyFavorites && (
                <ErrorBlock icon={<Star/>}>
                    Ваши избранные судозаходы будут отображаться на этой странице
                </ErrorBlock>
            )}
        </LoadingBox>
    );
}